import { delMediaFiles, uploadFiles } from "../../services/media";
import { DRYEYEMODES } from "../../shared/consts";
import DryEyeApi from "./algorithm/DryEyeApi";
import { getSystemTime, isDefined, isFunction, isNumNotNanOrInfinite } from "../../shared/utils";
import fileSys from "../../fileoprators/fileSystem";
let dryEyeApi = new DryEyeApi();
function getBatchNo() {
  let now = parseInt(Date.now() / 1000);
  let start = parseInt(new Date("1970-01-01").valueOf() / 1000);
  return now - start;
}

class DryEyeRecordProc {
  init(pat, record, mediafiles, eyetype, mode, data) {
    this.mediaFiles = mediafiles;
    this.mode = mode;
    this.eyeType = eyetype;
    this.data = data;

    this.osod = `data${this.eyeType}`;
    if (!isDefined(record)) {
      this.record = {
        patientid: pat._id,
        checktype: "dryeye",
        content: {
          dataOD: {
            batchNo: getBatchNo(),
            diagnosed: false
          },
          dataOS: {
            batchNo: getBatchNo(),
            diagnosed: false
          },
          userQuestionnaire: {
            Speed: [],
            DEQ: [],
            McMonnies: [],
            OSDI: [],
            DryEyeMain: [],
            diagnosed: false
          }
        }
      };
    } else {
      this.record = record;
    }
  }
  initRecord(mode, updown) {
    let _mode = isDefined(mode) ? mode : this.mode;
    this.record["eyetype"] = this.record["eyetype"] || [];
    if (this.record["eyetype"].indexOf(this.eyeType) < 0) {
      this.record["eyetype"].push(this.eyeType);
    }
    let tt = getSystemTime();
    this.record.testtime = tt;
    this.record.content[this.osod] = this.record.content[this.osod] || {};
    this.record.content[this.osod].diagnosed = true;
    if (!this.record.content[this.osod].recordtime) {
      this.record.content[this.osod].recordtime = tt;
    }
    if (mode === "fbut") {
      if (isDefined(window.captureSettings.FBUTtime) && window.captureSettings.FBUTtime === 1) {
        this.record.content[this.osod][_mode] = this.record.content[this.osod][_mode] || [];
        this.record.content[this.osod][_mode][0] = {};
        this.record.content[this.osod][_mode][0].diagnosed = true;
        this.record.content[this.osod][_mode][0].testtime = tt;
        this.record.content[this.osod][_mode][0]["photos"] =
          this.record.content[this.osod][_mode][0]["photos"] || [];
        if (
          this.record.content[this.osod][_mode].length > 1 &&
          this.record.content[this.osod][_mode][2].diagnosed
        ) {
          this.record.content[this.osod][_mode].pop();
        }
        if (
          this.record.content[this.osod][_mode].length > 1 &&
          this.record.content[this.osod][_mode][1].diagnosed
        ) {
          this.record.content[this.osod][_mode].pop();
        }
      } else {
        for (let i = 0; i < 3; i++) {
          this.record.content[this.osod][_mode] = this.record.content[this.osod][_mode] || [];
          this.record.content[this.osod][_mode][i] = {};
          this.record.content[this.osod][_mode][i].diagnosed = true;
          this.record.content[this.osod][_mode][i].testtime = tt;
          this.record.content[this.osod][_mode][i]["photos"] =
            this.record.content[this.osod][_mode][i]["photos"] || [];
        }
      }
      return;
    }
    this.record.content[this.osod][_mode] = this.record.content[this.osod][_mode] || {};
    this.record.content[this.osod][_mode].diagnosed = true;
    this.record.content[this.osod][_mode].testtime = tt;
    if (isDefined(updown)) {
      this.record.content[this.osod][_mode][updown] =
        this.record.content[this.osod][_mode][updown] || {};
      this.record.content[this.osod][_mode][updown]["photos"] =
        this.record.content[this.osod][_mode][updown]["photos"] || [];
    } else {
      this.record.content[this.osod][_mode]["photos"] =
        this.record.content[this.osod][_mode]["photos"] || [];
    }
  }
  procData(callback) {
    switch (this.mode) {
      case DRYEYEMODES.nibut.key:
        this.procNibut(callback);
        break;
      case DRYEYEMODES.fbut.key:
        this.procBut(callback);
        break;
      case DRYEYEMODES.blink.key:
        this.procBlink(callback);
        break;
      case DRYEYEMODES.tearheight.key:
        this.procTearHeihgt(callback);
        break;
      case DRYEYEMODES.lipidlayer.key:
        this.procLipidLayer(callback);
        break;
      case DRYEYEMODES.meibomian.key:
        this.procMeibomian(callback);
        break;
      case DRYEYEMODES.eyeredness.key:
        this.procEyeRedness(callback);
        break;
      case DRYEYEMODES.ocularsurface.key:
        this.procOcularSurface(callback);
        break;
      case DRYEYEMODES.eyelidedge.key:
        this.procEyeLidedge(callback);
        break;
    }
  }
  emitRecord(err, callback) {
    let cmd = isDefined(this.record._id) ? "updateRecord" : "addRecord";
    if (isFunction(callback)) {
      callback(err, cmd, this.record);
    }
  }
  deletePhotos(photos, callback) {
    delMediaFiles(photos, () => {
      if (isFunction(callback)) {
        callback();
      }
    });
  }
  beforeUpdate(mode, callback, upDown) {
    if (isDefined(this.record._id)) {
      if (isDefined(this.record.content[this.osod])) {
        if (isDefined(this.record.content[this.osod][mode])) {
          let photos;
          if (isDefined(upDown)) {
            photos = (this.record.content[this.osod][mode][upDown] || {})["photos"];
          } else if (mode === "fbut") {
            photos = [];
          } else {
            photos = this.record.content[this.osod][mode]["photos"];
          }
          photos = photos || [];
          if (mode !== "fbut") {
            this.deletePhotos(photos.concat(), () => {
              if (isDefined(upDown)) {
                this.record.content[this.osod][mode][upDown] = {};
                this.record.content[this.osod][mode][upDown]["photos"] = [];
              } else {
                this.record.content[this.osod][mode] = {};
                this.record.content[this.osod][mode]["photos"] = [];
              }
              if (isFunction(callback)) {
                callback();
              }
            });
          } else {
            if (isFunction(callback)) {
              callback();
            }
          }
        } else {
          if (isFunction(callback)) {
            callback();
          }
        }
      } else {
        if (isFunction(callback)) {
          callback();
        }
      }
    } else {
      if (isFunction(callback)) {
        callback();
      }
    }
  }
  procNibut(callback) {
    let videoPath = this.mediaFiles.videoPath;
    this.beforeUpdate(this.mode, () => {
      this.initRecord(this.mode);
      const keys = [
        "firstrupturetime",
        "avgruptruretime",
        "usefultime",
        "calcstarttime",
        "totaltime",
        "rupturetimes",
        "trendData"
      ];
      for (let id in keys) {
        this.record.content[this.osod][this.mode][keys[id]] = -1;
      }
      uploadFiles([videoPath], [], (data) => {
        if (data.message === "proc") return;
        if (data.message === "OK") {
          let fileinfo = data.fileInfos[0];
          if (isDefined(this.data)) {
            this.record.content[this.osod][this.mode]["firstrupturetime"] = this.data.firstTime; // 首次破裂时间
            this.record.content[this.osod][this.mode]["avgruptruretime"] = this.data.avgTime; // 平均破裂时间
            this.record.content[this.osod][this.mode]["usefultime"] = this.data.realLastTime; // 有效时间
            this.record.content[this.osod][this.mode]["totaltime"] = this.data.totalTime; // 录像总长度
            this.record.content[this.osod][this.mode]["rupturetimes"] = this.data.nibutTimePos; // 二维数组
            this.record.content[this.osod][this.mode]["calcstarttime"] = this.data.validStartTime; // 录像开始的时间
          }
          this.record.content[this.osod][this.mode]["photos"].push(fileinfo);

          // let ImagePath = fileSys.isFileExists('nibut.jpg')
          // this.procTearHeihgt(callback, DRYEYEMODES.tearheight.key, true)

          this.emitRecord(undefined, callback);
        } else if (data.message === "failed" || data.message === "no-file") {
          this.emitRecord(new Error("upload file error"), callback);
        }
      });
    });
  }
  procBut(callback) {
    if (isDefined(window.captureSettings.FBUTtime) && window.captureSettings.FBUTtime === 1) {
      let videoPath = this.mediaFiles.videoPath[0];
      this.beforeUpdate(this.mode, () => {
        this.initRecord(this.mode);
        const keys = [
          "firstrupturetime",
          "avgruptruretime",
          "usefultime",
          "calcstarttime",
          "totaltime",
          "rupturetimes",
          "trendData"
        ];
        for (let id in keys) {
          this.record.content[this.osod][this.mode][0][keys[id]] = -1;
        }
        // let arr = []
        // for (let index = 0; index < 400; index++) {
        //   arr.push(index)
        // }
        uploadFiles([videoPath], [], (data) => {
          if (data.message === "proc") return;
          if (data.message === "OK") {
            let fileinfo = data.fileInfos[0];
            if (isDefined(this.data[0])) {
              this.record.content[this.osod][this.mode][0]["firstrupturetime"] = window.__dryeye__
                .debug
                ? 10000
                : this.data[0].firstTime; // 首次破裂时间
              this.record.content[this.osod][this.mode][0]["avgruptruretime"] = window.__dryeye__
                .debug
                ? 10000
                : this.data[0].avgTime; // 平均破裂时间
              this.record.content[this.osod][this.mode][0]["usefultime"] = window.__dryeye__.debug
                ? 7.676324583242461
                : this.data[0].realLastTime; // 有效时间
              this.record.content[this.osod][this.mode][0]["totaltime"] = window.__dryeye__.debug
                ? 15.732501983642578
                : this.data[0].totalTime; // 录像总长度
              this.record.content[this.osod][this.mode][0]["rupturetimes"] = window.__dryeye__.debug
                ? arr
                : this.data[0].nibutTimePos; // 二维数组
              this.record.content[this.osod][this.mode][0]["calcstarttime"] = window.__dryeye__
                .debug
                ? 7.9703531265
                : this.data[0].validStartTime; // 录像开始的时间

              this.record.content[this.osod][this.mode][0]["lightradring"] = window.__dryeye__.debug
                ? 10
                : this.data[0].LightRadRing; // 光学区环数
              this.record.content[this.osod][this.mode][0]["firsttimelight"] = window.__dryeye__
                .debug
                ? 10000
                : this.data[0].firstTimeLight; // 光学区首次破裂时间
              // 光学区 破裂区域   obj.Set(Napi::String::New(env, "LightRadRing"), cam520->info->nibut_info->LightRadRing); // 光学区环数
              // obj.Set(Napi::String::New(env, "firstTimeLight"), cam520->info->nibut_info->Firsttime_light); // 光学区首次破裂时间
            }
            this.record.content[this.osod][this.mode][0]["photos"].push(fileinfo);

            this.emitRecord(undefined, callback);
          } else if (data.message === "failed" || data.message === "no-file") {
            this.emitRecord(new Error("upload file error"), callback);
          }
        });
      });
    } else {
      this.initRecord(this.mode);
      let videoPathOne = this.mediaFiles.videoPath[0];
      let videoPathTwo = this.mediaFiles.videoPath[1];
      let videoPathThree = this.mediaFiles.videoPath[2];
      this.beforeUpdate(this.mode, () => {
        const keys = [
          "firstrupturetime",
          "avgruptruretime",
          "usefultime",
          "calcstarttime",
          "totaltime",
          "rupturetimes",
          "trendData"
        ];
        for (let id in keys) {
          this.record.content[this.osod][this.mode][0][keys[id]] = -1;
          this.record.content[this.osod][this.mode][1][keys[id]] = -1;
          this.record.content[this.osod][this.mode][2][keys[id]] = -1;
        }
        if (window.__dryeye__.debug) {
          let arr = [];
          for (let index = 0; index < 400; index++) {
            arr.push(index);
          }
        }
        uploadFiles([videoPathThree, videoPathTwo, videoPathOne], [], (data) => {
          if (data.message === "proc") return;
          if (data.message === "OK") {
            for (let i = 0; i < 3; i++) {
              let fileinfo = data.fileInfos[i];
              if (isDefined(this.data[i])) {
                this.record.content[this.osod][this.mode][i]["firstrupturetime"] = window.__dryeye__
                  .debug
                  ? 10000
                  : this.data[i].firstTime; // 首次破裂时间
                this.record.content[this.osod][this.mode][i]["avgruptruretime"] = window.__dryeye__
                  .debug
                  ? 10000
                  : this.data[i].avgTime; // 平均破裂时间
                this.record.content[this.osod][this.mode][i]["usefultime"] = window.__dryeye__.debug
                  ? 7.676324583242461
                  : this.data[i].realLastTime; // 有效时间
                this.record.content[this.osod][this.mode][i]["totaltime"] = window.__dryeye__.debug
                  ? 15.732501983642578
                  : this.data[i].totalTime; // 录像总长度
                this.record.content[this.osod][this.mode][i]["rupturetimes"] = window.__dryeye__
                  .debug
                  ? arr
                  : this.data[i].nibutTimePos; // 二维数组
                this.record.content[this.osod][this.mode][i]["calcstarttime"] = window.__dryeye__
                  .debug
                  ? 7.9703531265
                  : this.data[i].validStartTime; // 录像开始的时间
                this.record.content[this.osod][this.mode][i]["lightradring"] = window.__dryeye__
                  .debug
                  ? 10
                  : this.data[i].LightRadRing; // 光学区环数
                this.record.content[this.osod][this.mode][i]["firsttimelight"] = window.__dryeye__
                  .debug
                  ? 10000
                  : this.data[i].firstTimeLight; // 光学区首次破裂时间
                // 光学区 破裂区域   obj.Set(Napi::String::New(env, "LightRadRing"), cam520->info->nibut_info->LightRadRing); // 光学区环数
                // obj.Set(Napi::String::New(env, "firstTimeLight"), cam520->info->nibut_info->Firsttime_light); // 光学区首次破裂时间
              }
              this.record.content[this.osod][this.mode][i]["photos"].push(fileinfo);
            }

            this.emitRecord(undefined, callback);
          } else if (data.message === "failed" || data.message === "no-file") {
            this.emitRecord(new Error("upload file error"), callback);
          }
        });
      });
    }
  }
  procBlink(callback) {
    let videoPath = this.mediaFiles.videoPath;
    this.beforeUpdate(this.mode, () => {
      this.initRecord(this.mode);
      const keys = [
        "NumNocmpltBlk",
        "NumCmpltBlk",
        "NumTotalBlk",
        "BlkInv",
        "RatioNocmpltBlk",
        "CmpltBlkInv",
        "blhArray",
        "timeArray",
        "resblhArray"
      ];
      for (let id in keys) {
        this.record.content[this.osod][this.mode][keys[id]] = -1;
      }
      uploadFiles([videoPath], [], (data) => {
        if (data.message === "proc") return;
        if (data.message === "OK") {
          let fileinfo = data.fileInfos[0];
          if (isDefined(this.data)) {
            this.record.content[this.osod][this.mode]["NumNocmpltBlk"] = window.__dryeye__.debug
              ? 6
              : this.data.NumNocmpltBlk; // 不完全眨眼次数
            this.record.content[this.osod][this.mode]["NumCmpltBlk"] = window.__dryeye__.debug
              ? 18
              : this.data.NumCmpltBlk; // 完全眨眼次数
            this.record.content[this.osod][this.mode]["NumTotalBlk"] = window.__dryeye__.debug
              ? 24
              : this.data.NumTotalBlk; // 总眨眼次数
            this.record.content[this.osod][this.mode]["BlkInv"] = window.__dryeye__.debug
              ? 2.5
              : this.data.BlkInv; // 总眨眼间隔
            this.record.content[this.osod][this.mode]["RatioNocmpltBlk"] = window.__dryeye__.debug
              ? 0.25
              : this.data.RatioNocmpltBlk; // 不完全眨眼比例
            this.record.content[this.osod][this.mode]["CmpltBlkInv"] = window.__dryeye__.debug
              ? 3.799
              : this.data.CmpltBlkInv; // 完全眨眼间隔, OPI的分母
            // this.record.content[this.osod][this.mode][
            //   'blhArray'
            // ] = window.__dryeye__.debug ? [] : this.data.blhArray // 眨眼程度序列
            // this.record.content[this.osod][this.mode][
            //   'timeArray'
            // ] = window.__dryeye__.debug ? [] : this.data.timeArray // 时间序列，和blhArray一一对应
            this.record.content[this.osod][this.mode]["resblhArray"] = window.__dryeye__.debug
              ? []
              : this.data.resblhArray; // 时间序列，和blhArray一一对应
          }
          this.record.content[this.osod][this.mode]["photos"].push(fileinfo);
          console.log(
            "timeArray blhArray",
            window.__dryeye__.debug ? [] : this.data.timeArray,
            window.__dryeye__.debug ? [] : this.data.blhArray
          );

          this.emitRecord(undefined, callback);
        } else if (data.message === "failed" || data.message === "no-file") {
          this.emitRecord(new Error("upload file error"), callback);
        }
      });
    });
  }
  calcAvg(arr) {
    if (!isDefined(arr) || arr.length === 0) {
      return Number.NaN;
    }
    let result = arr.reduce((total, num) => {
      return total + num;
    }, 0);
    return result / arr.length;
  }
  procTrendData(arrX, arrY, scale = 1) {
    const CNT = 10;
    let X = [];
    let Y = [];
    if (isDefined(arrX) && isDefined(arrY)) {
      let _arrX = arrX.concat();
      let _arrY = arrY.concat();
      let num = Math.ceil(_arrX.length / CNT);
      for (let id = 0; id < num; id++) {
        let avgX = this.calcAvg(_arrX.splice(0, CNT));
        let avgY = this.calcAvg(_arrY.splice(0, CNT));
        if (isNumNotNanOrInfinite(avgX) && isNumNotNanOrInfinite(avgY)) {
          X.push(avgX * scale);
          Y.push(avgY * scale);
        }
      }
    }
    return {
      X: X,
      Y: Y
    };
  }
  procTearHeihgt(callback, mode, isFromNibut = false) {
    let _mode = isDefined(mode) ? mode : this.mode;
    this.beforeUpdate(_mode, () => {
      let imagePath = this.mediaFiles.imagePath;
      let trendImagePath = fileSys.getMediaPath("trend.jpg"); // 趋势图的路径
      let printImagePath = fileSys.getMediaPath("print.jpg"); // 打印图的路径
      let uiImagePath = fileSys.getMediaPath("ui.jpg"); // 原图的路径
      let type = !!window.captureSettings.TearheightSelectLight ? "bg" : "hw";
      let result = dryEyeApi.calcTearHeight(imagePath, type);

      if (
        (isDefined(result) &&
          (result.upArrayX.length > 0 || window.captureSettings.EyeMaterial === 1)) ||
        window.__dryeye__.debug
      ) {
        this.initRecord(_mode);
        let scale = isFromNibut ? 2 : 1;
        this.record.content[this.osod][_mode].trendData = this.procTrendData(
          result.tearArrayX,
          result.tearArrayY,
          scale
        );
        console.log(
          "this.record.content[this.osod][_mode].trendData:",
          this.record.content[this.osod][_mode].trendData
        );
        this.record.content[this.osod][_mode].trensdDataXlength = window.__dryeye__.debug
          ? 601
          : result.trensdDataXlength; // 数据大小
        this.record.content[this.osod][_mode].trensdDataYHeigth = window.__dryeye__.debug
          ? 200
          : result.trensdDataYHeigth * scale; // 泪河高度值 px
        // this.record.content[this.osod][_mode].autocalcPoint = result.autocalcPoint
        this.record.content[this.osod][_mode].trenddatacenter = window.__dryeye__.debug
          ? 1165
          : result.trensdDataCenter * scale; // 数据中心点
        this.record.content[this.osod][_mode].autocalcavg = window.__dryeye__.debug
          ? 34.7748
          : result.tearHeigthAVG; // 暂时不用
        this.record.content[this.osod][_mode].autocalcarea = window.__dryeye__.debug
          ? 21716
          : result.tearHeigthArea; // 泪河
        this.record.content[this.osod][_mode].from = isFromNibut ? "nibut" : "tearheight"; // 图像来源
        this.record.content[this.osod][_mode].tearArrayX = result.tearArrayX;
        this.record.content[this.osod][_mode].tearArrayY = result.tearArrayY;
        this.record.content[this.osod][_mode].upArrayX = result.upArrayX;
        this.record.content[this.osod][_mode].upArrayY = result.upArrayY;
        this.record.content[this.osod][_mode].downArrayX = result.downArrayX;
        this.record.content[this.osod][_mode].downArrayY = result.downArrayY;
        this.record.content[this.osod][_mode].lightType = type;
        this.record.content[this.osod][_mode].autocalcPoint = {
          // 绘制自动泪河的坐标值 px
          upX: window.__dryeye__.debug ? 1227 : result.autocalcPointUpX, // 上X
          upY: window.__dryeye__.debug ? 1282 : result.autocalcPointUpY,
          downX: window.__dryeye__.debug ? 1227 : result.autocalcPointDownX,
          downY: window.__dryeye__.debug ? 1316 : result.autocalcPointDownY
        };
        let labels = ["original", "print"];
        let images = [uiImagePath, printImagePath];
        if (fileSys.isFileExists(trendImagePath)) {
          labels.push("trend");
          images.push(trendImagePath);
        }
        /// let uploadFiles = result === undefined || (result && result.trensdDataXlength === -1) ? [imagePath] : [imagePath, trendImagePath, printImagePath]
        this.uploadAllFiles(
          images,
          labels,
          "",
          this.record.content[this.osod][_mode]["photos"],
          (error) => {
            this.emitRecord(error, callback);
          }
        );
      } else {
        this.emitRecord(new Error("upload file error"), callback);
      }
    });
  }
  uploadAllFiles(imagePaths, imageLabels, upDown, photos, callback) {
    if (imagePaths.length <= 0) {
      if (isFunction(callback)) {
        callback(null, photos);
      }
    } else {
      let _path = imagePaths.pop();
      let _label = imageLabels.pop();
      uploadFiles([_path], [], (data) => {
        if (data.message === "proc") return;
        if (data.message === "OK") {
          let fileinfo = data.fileInfos[0];
          fileinfo.imagelabel = _label;
          fileinfo.direction = upDown;
          photos.push(fileinfo);
          this.uploadAllFiles(imagePaths, imageLabels, upDown, photos, callback);
        } else {
          if (callback) callback(new Error("upload file failed"));
        }
      });
    }
  }
  recalculateTearHeihgt(record, photo, currentEye, callback) {
    let imagePath = fileSys.getUploadPath(photo.filename);
    let trendImagePath = fileSys.getMediaPath("trend.jpg"); // 趋势图的路径
    let printImagePath = fileSys.getMediaPath("print.jpg"); // 打印图的路径
    let uiImagePath = fileSys.getMediaPath("ui.jpg"); // 原图的路径
    let result = dryEyeApi.calcTearHeight(
      imagePath,
      record.content[`data${currentEye}`]["tearheight"].lightType || "bg"
    );

    if (isDefined(result)) {
      record.content[`data${currentEye}`]["tearheight"].trendData = this.procTrendData(
        result.tearArrayX,
        result.tearArrayY,
        1
      );
      console.log(
        "record.content[`data${currentEye}`][tearheight],trendData:",
        record.content[`data${currentEye}`]["tearheight"].trendData
      );
      record.content[`data${currentEye}`]["tearheight"].trensdDataXlength = window.__dryeye__.debug
        ? 601
        : result.trensdDataXlength; // 数据大小
      record.content[`data${currentEye}`]["tearheight"].trensdDataYHeigth = window.__dryeye__.debug
        ? 200
        : result.trensdDataYHeigth * 1; // 泪河高度值 px
      // record.content[`data${currentEye}`]['tearheight'].autocalcPoint = result.autocalcPoint
      record.content[`data${currentEye}`]["tearheight"].trenddatacenter = window.__dryeye__.debug
        ? 1165
        : result.trensdDataCenter * 1; // 数据中心点
      record.content[`data${currentEye}`]["tearheight"].autocalcavg = window.__dryeye__.debug
        ? 34.7748
        : result.tearHeigthAVG; // 暂时不用
      record.content[`data${currentEye}`]["tearheight"].autocalcarea = window.__dryeye__.debug
        ? 21716
        : result.tearHeigthArea; // 泪河
      record.content[`data${currentEye}`]["tearheight"].from = "tearheight"; // 图像来源
      record.content[`data${currentEye}`]["tearheight"].tearArrayX = result.tearArrayX;
      record.content[`data${currentEye}`]["tearheight"].tearArrayY = result.tearArrayY;
      record.content[`data${currentEye}`]["tearheight"].upArrayX = result.upArrayX;
      record.content[`data${currentEye}`]["tearheight"].upArrayY = result.upArrayY;
      record.content[`data${currentEye}`]["tearheight"].downArrayX = result.downArrayX;
      record.content[`data${currentEye}`]["tearheight"].downArrayY = result.downArrayY;
      record.content[`data${currentEye}`]["tearheight"].autocalcPoint = {
        // 绘制自动泪河的坐标值 px
        upX: window.__dryeye__.debug ? 1227 : result.autocalcPointUpX, // 上X
        upY: window.__dryeye__.debug ? 1282 : result.autocalcPointUpY,
        downX: window.__dryeye__.debug ? 1227 : result.autocalcPointDownX,
        downY: window.__dryeye__.debug ? 1316 : result.autocalcPointDownY
      };
      if (record.content[`data${currentEye}`]["tearheight"]["photos"])
        record.content[`data${currentEye}`]["tearheight"]["photos"] = [];
      let labels = ["original", "trend", "print"];
      this.uploadAllFiles(
        [uiImagePath, trendImagePath, printImagePath],
        labels,
        "",
        [],
        (err, photos) => {
          if (err) {
            if (callback) callback(new Error("procTearHeihgt failed"), record);
          } else {
            record.content[`data${currentEye}`]["tearheight"]["photos"] = photos.concat();
            // this.emitRecord(error, callback)
            console.log(
              "uploadAll----success",
              record.content[`data${currentEye}`]["tearheight"]["photos"]
            );
            fileSys.deleteFile(fileSys.getMediaPath("ui.jpg"));
            fileSys.deleteFile(fileSys.getMediaPath("print.jpg"));
            fileSys.deleteFile(fileSys.getMediaPath("trend.jpg"));
          }
          if (callback) callback(err, record);
        }
      );
    } else {
      if (callback) callback(result, record);
    }
  }
  procManualMeibomianImage(
    imagePath,
    imagePathEnhance,
    imagePathContour,
    imagePathPrint,
    imagePathEnhancePrint,
    imagePathContourPrint,
    upDown,
    data,
    callback
  ) {
    if (!isDefined(imagePath)) {
      if (isDefined(callback)) {
        callback();
      }
      return;
    }
    this.initRecord(this.mode, upDown);

    let result = dryEyeApi.calcMebomian(imagePath, upDown, data);

    if (isDefined(result)) {
      this.record.content[this.osod][this.mode][upDown] =
        this.record.content[this.osod][this.mode][upDown] || {};
      this.record.content[this.osod][this.mode][upDown]["glandloss"] = result.GlandLoss;
      this.record.content[this.osod][this.mode][upDown]["glandpercent"] = result.Percent;
    }
    let labels = ["enhance", "contour", "print", "enhancePrint", "contourPrint"];
    this.uploadAllFiles(
      [
        imagePathEnhance,
        imagePathContour,
        imagePathPrint,
        imagePathEnhancePrint,
        imagePathContourPrint
      ],
      labels,
      upDown,
      this.record.content[this.osod][this.mode][upDown]["photos"],
      (error) => {
        if (!isDefined(error)) {
          callback(error, result);
        } else {
          console.log("error", error);
        }
      }
    );
  }
  procMeibomianImage(
    imagePath,
    imagePathEnhance,
    imagePathContour,
    imagePathPrint,
    imagePathEnhancePrint,
    imagePathContourPrint,
    upDown,
    callback
  ) {
    if (!isDefined(imagePath)) {
      if (isFunction(callback)) {
        callback();
      }
      return;
    }
    this.beforeUpdate(
      this.mode,
      () => {
        this.initRecord(this.mode, upDown);
        let result = dryEyeApi.calcMebomian(imagePath, upDown, undefined);
        if (isDefined(result)) {
          this.record.content[this.osod][this.mode][upDown]["glandloss"] = result.GlandLoss;
          this.record.content[this.osod][this.mode][upDown]["glandpercent"] = result.Percent;
        }
        let labels = ["original", "enhance", "contour", "print", "enhancePrint", "contourPrint"];
        console.log(
          "procMeibomianImage",
          imagePathPrint,
          imagePathEnhancePrint,
          imagePathContourPrint
        );
        this.uploadAllFiles(
          [
            imagePath,
            imagePathEnhance,
            imagePathContour,
            imagePathPrint,
            imagePathEnhancePrint,
            imagePathContourPrint
          ],
          labels,
          upDown,
          this.record.content[this.osod][this.mode][upDown]["photos"],
          (error) => {
            if (isFunction(callback)) {
              callback(error);
            }
          }
        );
      },
      upDown
    );
  }
  procMeibomian(callback) {
    // if (isDefined(this.mediaFiles.imagePathUp)) {
    //   let resUp = dryEyeApi.enhanceMeibomianImg(this.mediaFiles.imagePathUp)
    //   console.log('procMeibomian UP', resUp)
    // }
    // if (isDefined(this.mediaFiles.imagePathDown)) {
    //   let resDown = dryEyeApi.enhanceMeibomianImg(this.mediaFiles.imagePathDown)
    //   console.log('procMeibomian Down', resDown)
    // }
    let imagePathUp = this.mediaFiles.imagePathUp;
    let imagePathDown = this.mediaFiles.imagePathDown;

    let imagePathEnhance = fileSys.getMediaPath("enhance.jpg");
    let imagePathContour = fileSys.getMediaPath("contour.jpg");
    let imagePathEnhancePrint = fileSys.getMediaPath("enhance_print.jpg");
    let imagePathContourPrint = fileSys.getMediaPath("contour_print.jpg");
    let imagePathPrint = fileSys.getMediaPath("print.jpg");
    if (isDefined(imagePathUp)) {
      this.procMeibomianImage(
        imagePathUp,
        imagePathEnhance,
        imagePathContour,
        imagePathPrint,
        imagePathEnhancePrint,
        imagePathContourPrint,
        "up",
        (error) => {
          if (!isDefined(error)) {
            if (isDefined(imagePathDown)) {
              this.procMeibomianImage(
                imagePathDown,
                imagePathEnhance,
                imagePathContour,
                imagePathPrint,
                imagePathEnhancePrint,
                imagePathContourPrint,
                "down",
                (error) => {
                  if (!isDefined(error)) {
                    this.emitRecord(error, callback);
                  } else {
                    this.emitRecord(new Error("upload file error"), callback);
                  }
                }
              );
            } else {
              this.emitRecord(error, callback);
            }
          } else {
            this.emitRecord(new Error("upload file error"), callback);
          }
        }
      );
    } else {
      this.procMeibomianImage(
        imagePathDown,
        imagePathEnhance,
        imagePathContour,
        imagePathPrint,
        imagePathEnhancePrint,
        imagePathContourPrint,
        "down",
        (error) => {
          if (!isDefined(error)) {
            this.emitRecord(error, callback);
          } else {
            this.emitRecord(new Error("upload file error"), callback);
          }
        }
      );
    }
  }
  procLipidLayer(callback) {
    let videoPath = this.mediaFiles.videoPath;
    let imagePath = this.mediaFiles.imagePath;
    this.beforeUpdate(this.mode, () => {
      this.initRecord(this.mode);
      uploadFiles([videoPath, imagePath], [], (data) => {
        if (data.message === "proc") return;
        if (data.message === "OK") {
          let fileinfovideo = data.fileInfos[1];
          let fileinfojpg = data.fileInfos[0];
          fileinfojpg.imagelabel = "original";
          this.record.content[this.osod][this.mode]["photos"].push(fileinfovideo);
          this.record.content[this.osod][this.mode]["photos"].push(fileinfojpg);
          this.emitRecord(null, callback);
        } else {
          this.emitRecord(new Error("uploaf file  error"), callback);
        }
      });
    });
  }
  procEyeRedness(callback) {
    let imagePath = this.mediaFiles.imagePath;
    let filepathEnhance = fileSys.getMediaPath("enhance.jpg");
    let filepathBulbar = fileSys.getMediaPath("maskall.jpg");
    let filepathCiliary = fileSys.getMediaPath("maskpart.jpg");
    let filepathprint = fileSys.getMediaPath("cropYHImage.jpg");
    this.beforeUpdate(this.mode, () => {
      this.initRecord(this.mode);
      let result = dryEyeApi.calcEyeRedness(imagePath);
      if (isDefined(result)) {
        this.record.content[this.osod][this.mode]["nasalciliary"] = result.ratioleft;
        this.record.content[this.osod][this.mode]["tempciliary"] = result.ratioleft_part;
        this.record.content[this.osod][this.mode]["nasalconjunctival"] = result.ratioright;
        this.record.content[this.osod][this.mode]["tempconjunctival"] = result.ratioright_part;
      }
      let labels = ["original", "enhance", "bular", "ciliary", "print"];

      this.uploadAllFiles(
        [imagePath, filepathEnhance, filepathBulbar, filepathCiliary, filepathprint],
        labels,
        "",
        this.record.content[this.osod][this.mode]["photos"],
        (error) => {
          if (!isDefined(error)) {
            this.emitRecord(error, callback);
          } else {
            this.record.content[this.osod][this.mode].diagnosed = false;
            this.emitRecord(new Error("upload file error"), callback);
          }
        }
      );
    });
  }
  procOcularSurface(callback) {
    let imagePath = this.mediaFiles.imagePath;
    this.beforeUpdate(this.mode, () => {
      this.initRecord(this.mode);
      uploadFiles([imagePath], [], (data) => {
        if (data.message === "proc") return;
        if (data.message === "OK") {
          let fileinfo = data.fileInfos[0];
          fileinfo.imagelabel = "original";
          this.record.content[this.osod][this.mode]["photos"].push(fileinfo);
          this.emitRecord(null, callback);
        } else {
          this.emitRecord(new Error("uploaf file  error"), callback);
        }
      });
    });
  }

  procEyeLidedgeImage(imagePath, imagePathPrint, upDown, start, end, callback) {
    this.beforeUpdate(
      this.mode,
      () => {
        if (!isDefined(imagePath)) {
          if (isDefined(callback)) callback();
        } else {
          this.initRecord(this.mode, upDown);
          let result = dryEyeApi.calcEyelidEdge(imagePath, start, end);
          if (isDefined(result)) {
            let labels = ["original", "print"];
            this.uploadAllFiles(
              [imagePath, imagePathPrint],
              labels,
              upDown,
              this.record.content[this.osod][this.mode][upDown]["photos"],
              (error) => {
                if (isFunction(callback)) {
                  callback(error);
                }
              }
            );
          } else {
            if (isDefined(callback)) {
              callback(new Error("upload file error"));
            }
          }
        }
      },
      upDown
    );
  }
  procEyeLidedge(callback) {
    let imagePathUp = this.mediaFiles.imagePathUp;
    let imagePathDown = this.mediaFiles.imagePathDown;
    let imagePathUpPrint = fileSys.getMediaPath("jianyanCrop.jpg");
    let imagePathDownPrint = fileSys.getMediaPath("jianyanCrop.jpg");
    if (isDefined(imagePathUp)) {
      this.procEyeLidedgeImage(imagePathUp, imagePathUpPrint, "up", 280, 980, (error) => {
        if (!isDefined(error)) {
          if (isDefined(imagePathDown)) {
            this.procEyeLidedgeImage(
              imagePathDown,
              imagePathDownPrint,
              "down",
              380,
              1080,
              (error) => {
                this.emitRecord(error, callback);
              }
            );
          } else {
            this.emitRecord(error, callback);
          }
        } else {
          this.emitRecord(new Error("upload file error"), callback);
        }
      });
    } else {
      if (isDefined(imagePathDown)) {
        this.procEyeLidedgeImage(imagePathDown, imagePathDownPrint, "down", 380, 1080, (error) => {
          this.emitRecord(error, callback);
        });
      } else {
        this.emitRecord(undefined, callback);
      }
    }
  }

  // procMeibomian () {}

  // procLipidLayer () {}

  // procEyeRedness () {}

  // procOcularSurface () {}

  // procEyeLidedge () {}

  /* 重新拍摄、重新分析**/

  /* 睑板腺重新分析,photoName:图片名称,已经上传到服务器的图片，需要下载下来之后在分析;
      data:睑板腺分析区域;needDelPhotos:需要删除的图片，调用者传 */
  // 先从服务器下载图片到Media文件夹中文件名是_temp.jpg,再调用算法分析图片,并上传
  reAnalyzeMeibomian(photoName, data, mode, upDown, callback) {
    // downloadFile(photoName, fileSys.getMediaPath(), '_temp.jpg', (err) => {
    //   if (err) {
    //     console.log(err)
    //   } else {
    let imagePathEnhance = fileSys.getMediaPath("enhance.jpg");
    let imagePathContour = fileSys.getMediaPath("contour.jpg");
    let imagePathPrint = fileSys.getMediaPath("print.jpg");
    let imagePathEnhancePrint = fileSys.getMediaPath("enhance_print.jpg");
    let imagePathContourPrint = fileSys.getMediaPath("contour_print.jpg");
    let needDelPhotos = this.record.content[this.osod][mode][upDown]["photos"].filter((e) => {
      return e.imagelabel !== "original";
    });
    delMediaFiles(needDelPhotos, () => {
      if (isDefined(mode) && isDefined(upDown)) {
        this.record.content[this.osod][mode][upDown]["photos"] = [photoName];
      }
      this.procManualMeibomianImage(
        photoName.filePath,
        imagePathEnhance,
        imagePathContour,
        imagePathPrint,
        imagePathEnhancePrint,
        imagePathContourPrint,
        upDown,
        data,
        (error, result) => {
          if (error) {
            console.log("error", error);
          } else {
            this.record.content[this.osod][mode][upDown].glandloss = result.GlandLoss;
            this.record.content[this.osod][mode][upDown].glandpercent = result.Percent;

            callback(result, this.record);
          }
        }
      );
    });
  }
  // })
  // }
}
export default DryEyeRecordProc;



// WEBPACK FOOTER //
// ./src/dryeye/js/DryEyeRecordProc.js